@if (isLoadingData && filters) {
<div class="my-2">
    <app-stores-multiple-input-filter [tableFilters]="filters" (selectedFilter)="onSelectedFilter($event)">
    </app-stores-multiple-input-filter>
</div>
}

<div class="container">
    @if (isPremiseRows() && !isLoadingResults) {
    <div class="store-container">
        @for (premiseRow of premiseRows; track premiseRow) {
        <div>
            <app-premise [premiseRow]="premiseRow"></app-premise>
        </div>
        }
    </div>
    }

    @if (isLoadingResults) {
    <div class="loading-shade">
        <mat-spinner></mat-spinner>
    </div>
    }
</div>